/** singleton of event channels */
import Backbone from 'backbone';

const _eventChannels = {
    media: {
        imageEditor: {},
        videoEditor: {},
        library: {},
        package: {},
    },
    preview: {},
    syndication: {},
    tagging: {},
    targeting: {},
};

export function turnObjIntoEventRadio(obj) {
    return Object.keys(obj).reduce(function(prev, curr) {
        if (Object.keys(obj[curr]).length) {
            prev[curr] = turnObjIntoEventRadio(obj[curr]);
        } else {
            prev[curr] = obj[curr];
        }

        prev[curr] = Object.assign(prev[curr], Backbone.Events);

        return prev;
    }, {});
}

export default Object.assign(turnObjIntoEventRadio(_eventChannels), Backbone.Events);
